import { Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { shape, string } from 'prop-types';
import React from 'react';
import remark from 'remark';
import remark2react from 'remark-react';
import template from 'string-placeholder';
import { MainHeading, NormalText } from '../typography';

const useStyles = makeStyles((theme) => ({
  listItem: {
    fontFamily: theme.typography.fontFamily,
  },
}));

function MdLink({ href, ...props }) {
  const target = href.startsWith('mailto:') ? '' : '_blank';
  return (
    <Link href={href} rel="noopener noreferrer" target={target} {...props} />
  );
}

MdLink.propTypes = {
  href: string,
};

MdLink.defaultProps = {
  href: undefined,
};

function Markdown({ children, remarkReactComponents, extend, tags }) {
  const classes = useStyles();
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {
        remark()
          .use(remark2react, {
            remarkReactComponents: remarkReactComponents || {
              h1: (props) => <MainHeading {...props} />,
              h2: (props) => (
                <Typography gutterBottom variant="h2" {...props} />
              ),
              h3: (props) => (
                <Typography gutterBottom variant="h3" {...props} />
              ),
              h4: (props) => (
                <Typography gutterBottom variant="h4" {...props} />
              ),
              h5: (props) => (
                <Typography gutterBottom variant="h5" {...props} />
              ),
              h6: (props) => (
                <Typography gutterBottom variant="h6" {...props} />
              ),
              p: (props) => <NormalText {...props} />,
              a: (props) => <MdLink {...props} />,
              li: (props) => <li {...props} className={classes.listItem} />,
              ...extend,
            },
          })
          .processSync(template(children, tags)).contents
      }
    </>
  );
}

Markdown.propTypes = {
  children: string.isRequired,
  extend: shape({}),
  remarkReactComponents: shape({}),
  tags: shape({}),
};

Markdown.defaultProps = {
  extend: undefined,
  remarkReactComponents: undefined,
  tags: {},
};

export default Markdown;
